"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get APPOINTMENT_STATUS_LABELS () {
        return APPOINTMENT_STATUS_LABELS;
    },
    get APPOINTMENT_STATUS_TRANSITIONS () {
        return APPOINTMENT_STATUS_TRANSITIONS;
    },
    get AppointmentStatusSchema () {
        return AppointmentStatusSchema;
    },
    get canTransition () {
        return canTransition;
    }
});
const _zod = require("zod");
const AppointmentStatusSchema = _zod.z.enum([
    'scheduled',
    'checked_in',
    'in_consult',
    'completed',
    'no_show',
    'cancelled'
]);
const APPOINTMENT_STATUS_LABELS = {
    scheduled: 'Scheduled',
    checked_in: 'Checked-in',
    in_consult: 'In consult',
    completed: 'Completed',
    no_show: 'No-show',
    cancelled: 'Cancelled'
};
const APPOINTMENT_STATUS_TRANSITIONS = Object.freeze({
    scheduled: Object.freeze([
        'checked_in',
        'no_show',
        'cancelled'
    ]),
    checked_in: Object.freeze([
        'in_consult',
        'scheduled',
        'no_show'
    ]),
    in_consult: Object.freeze([
        'completed',
        'checked_in'
    ]),
    no_show: Object.freeze([
        'checked_in'
    ]),
    completed: Object.freeze([]),
    cancelled: Object.freeze([])
});
function canTransition(from, to) {
    if (from === to) {
        return false;
    }
    return APPOINTMENT_STATUS_TRANSITIONS[from].includes(to);
}
